import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { signRedirect } from '../lib/crypto';

export const AuthGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    async function checkAuth() {
      if (!loading && !user && !redirecting) {
        setRedirecting(true);
        const fullPath = location.pathname + location.search;
        const signedState = await signRedirect(fullPath);
        navigate(`/login?redirect=${signedState}`, { replace: true });
      }
    }
    checkAuth();
  }, [user, loading, location, navigate, redirecting]);

  if (loading || (!user && redirecting)) {
    return (
      <div className="flex min-h-[calc(100vh-3.5rem)] items-center justify-center bg-paper-50 dark:bg-study-slate">
        <div className="text-center">
          <div className="mx-auto h-6 w-6 animate-spin rounded-full border-2 border-zinc-400 border-t-zinc-800 dark:border-zinc-600 dark:border-t-zinc-200" />
          <p className="mt-3 font-mono text-xs uppercase tracking-widest text-zinc-500 dark:text-zinc-400">
            Verificando credenciais...
          </p>
        </div>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return <>{children}</>;
};
